import { useState } from "react";
import i18n from "../../i18n";
import YuJaDialog from "../standardization/YuJaDialog";
import { useTranslation } from "react-i18next";

export default function DiscardChangesConfirmationModal({
    show,
    setShow,
    handleSubmit,
    title = i18n.t("poll.discardButton"),
    bodyText = i18n.t("common.discardChangesConfirm"),
    confirmText = i18n.t("poll.discardButton"),
}) {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = useState(false);

    return (
        <YuJaDialog
            open={show}
            setOpen={setShow}
            title={title}
            closeText={t("common.cancel")}
            submitText={confirmText}
            isSubmitBtnDisabled={isSubmitting}
            fitContent
            onSubmit={async () => {
                setIsSubmitting(true);
                await handleSubmit();
                setIsSubmitting(false);
            }}
        >
            {bodyText}
        </YuJaDialog>
    );
}
